import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function ReasonDialog({ open, onOpenChange, title, description, confirmLabel, onConfirm, testId, required = true }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      await onConfirm(reason);
      setReason("");
      onOpenChange(false);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={`${testId}-dialog`}>
        <DialogHeader><DialogTitle className="font-serif-it text-2xl">{title}</DialogTitle></DialogHeader>
        <p className="text-sm text-[#47606B]">{description}</p>
        <textarea data-testid={`${testId}-reason`} rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motivo (verrà registrato)"
          className="w-full rounded-md border border-[#D4E6EC] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#0B6E8F]/30" />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid={`${testId}-cancel`}>Indietro</Button>
          <Button variant="destructive" disabled={busy || (required && !reason.trim())} onClick={go} data-testid={`${testId}-confirm`}>{confirmLabel}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
